<button type="button" class="btn btn-white btn-sm btn-block" ng-click="showHistoricoAlteracoes()">
  <i class="fa fa-history"></i> {{title}}
</button>

<script type="text/ng-template" id="modal-historico-alteracoes.html">
  <div class="modal-header">
    <button type="button" class="close" ng-click="close()">&times;</button>
    <h3 class="modal-title pull-left">
      {{title}}
    </h3>
  </div>
  <div class="historico-alteracoes modal-body">
    <div class="text-center">
      <div class="btn-group navigation-buttons">
        <button class="btn btn-white btn-sm" ng-click="prior()" ng-disabled="index <= 1" title="Anterior">
          <i class="fa fa-arrow-left"></i>
        </button>
        <button class="btn btn-white btn-sm" ng-click="next()" ng-disabled="index === historicos.length - 1" title="Próximo">
          <i class="fa fa-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="row container-diff" ng-show="!hide">
      <div class="col-xs-6" ng-repeat="historico in historicosToCompare">
        <div class="panel panel-default">
          <div class="panel-heading"><span class="status">{{historico.status}}</span> por {{historico.usuario.nome_completo}} em {{historico.created_at | date:'dd/MM/yyyy \'às\' HH:mm:ss'}}</div>
          <div ng-bind-html="historico.diff" class="json panel-body"></div>
        </div>
      </div>
    </div>
  </div>
</script>
